import { TranslateService } from "@ngx-translate/core";
var P500Component = /** @class */ (function () {
    function P500Component(translate) {
        this.translate = translate;
    }
    return P500Component;
}());
export { P500Component };
